import { render, staticRenderFns } from "./drp_send_list.vue?vue&type=template&id=6a0ddaf5&"
import script from "./drp_send_list.vue?vue&type=script&lang=js&"
export * from "./drp_send_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports